<div class="card" fxLayout="row" fxLayout.lt-md="column">
  <button class="menu" mat-button [matMenuTriggerFor]="menu">
    <jam-icon name="more-vertical-f" />
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="delete()">
      حذف <jam-icon name="trash" />
    </button>
  </mat-menu>

  <div
    class="mat-card-content"
    fxLayout="column"
    fxLayoutAlign="space-between start"
  >
    <span class="address">{{ address.address }}</span>

    <div
      class="info-action-wrapper"
      fxLayout="row"
      fxLayout.lt-md="column"
      fxLayoutAlign="space-between center"
    >
      <div class="infos" fxFlex="70" fxLayout="row wrap" fxLayoutAlign="start">
        <div class="info reciver">نام گیرنده: {{ address.recipientName }}</div>
        <div class="info phone-number">
          شماره تلفن همراه: {{ address.phoneNumber }}
        </div>
        <div class="info telephon-number">
          شماره تلفن ثابت‌{{ address.houseNumber }}
        </div>
        <div class="info province">استان: {{ address.province }}</div>
        <div class="info city">شهر: {{ address.city }}</div>
        <div class="info postal-code">کد پستی: {{ address.postalCode }}</div>
      </div>
      <div class="actions" fxFlex="15" fxLayout="row" fxLayoutAlign="end end">
        <button (click)="edit()" mat-stroked-button color="primary">
          <span>ویرایش آدرس</span>
        </button>
      </div>
    </div>
  </div>

  <!-- <mat-checkbox #matCheckBox *ngIf="isSelected" [checked]="false"  class="disable-event selected-checkbox-absolute" color="primary"></mat-checkbox> -->
</div>
